import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { BODY_FONT, g, t, TICKET } from '../../HomeScreen/HomeScreen.styles';

const Container = styled('section')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: `max(180px, ${g(300)})`,
});

const Title = styled('h2')({
  fontSize: t(30),
  lineHeight: 1.2,
  letterSpacing: '-0.01em',
  fontWeight: 700,
  fontFamily: BODY_FONT,
  color: TICKET.labelInk,
  margin: 0,
  textAlign: 'center',
});

export const FinalizingBlock: FC = () => {
  return (
    <Container aria-label="Finalizing">
      <Title>Just a moment</Title>
    </Container>
  );
};
